import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "lib/axios";

export const useNewsletterReviewCount = (): UseQueryResult<number> => {
  return useQuery({
    queryKey: ["newsletters-review-count"],
    queryFn: async () => {
      const { data } = await axios.get("/newsletters/review/count");
      return data.count;
    },
  });
};



